'use strict';

module.exports = require('../services/createErrorClass')({
	name: 'UserLinkPending',
	message:
		'This user has already been invited to link their billing. They must accept or decline this request before being invited to link again.',
	soft: true
});
